module.exports = __webpack_public_path__ + "static/media/so-stock--cow4.3e253848.jpg";